module.exports = __webpack_public_path__ + "img/ic-smartplug-inactive.f4beca64.svg";